<div mat-dialog-content>
  <p class = "bodyMedium colorNeutral60">{{data.message}}</p>
</div>
<mat-divider></mat-divider>
<div class="actions" mat-dialog-actions>
  <button mat-button color="primary" (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onConfirm()" cdkFocusInitial data-cy="confirm-chat-delete-button">Confirm</button>
</div>
